import { VehicleType } from '../../../../../models/experiencefragments/vehicle-type';
import { DisclaimerList } from '../../../../common/disclaimer-list/disclaimer-list';
import { useFeatureRibbonContent } from '../../../../../hooks/dyf/use-feature-ribbon-content/use-feature-ribbon-content';

interface FeatureRibbonProps {
    vin: string;
    vehicleType: VehicleType;
    eligibleTowingCalculator: boolean;
}
export const FeatureRibbonDisclaimerFooter = (props: FeatureRibbonProps) => {
    const featureRibbonContent = useFeatureRibbonContent(
        props.vin,
        props.vehicleType,
        props.eligibleTowingCalculator
    );

    return (
        <DisclaimerList
            disclaimers={featureRibbonContent
                .filter(elem => elem.disclaimer)
                .flatMap(elem => ({
                    content: elem.disclaimer!,
                    symbol: `${elem.disclaimerIndex}`,
                }))}
        />
    );
};
